import React, { useContext, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router';

import type { GroupProps } from '@swf/core/types/Wizard';
import { canUseDOM, integrationTesting } from '@swf/core/utils';

import { Node } from '../../Flow';
import { FlowContext } from '../../StarsWizard';

const Group: React.FunctionComponent<GroupProps> = ({
  name,
  children,
  flow,
  transition: Transition,
  ...options
}) => {
  const parent = useContext(FlowContext);
  const [node] = useState(new Node(name, flow, options, parent));
  const location = useLocation();

  return (
    <FlowContext.Provider value={node}>
      {Transition && !integrationTesting && canUseDOM ? (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        React.Children.map<React.ReactElement, any>(children, (element: React.ReactElement) => (
          <Route path={node.getPath(element.type)}>
            {({ match }) => <Transition in={match != null}>{element}</Transition>}
          </Route>
        ))
      ) : (
        <Switch location={location}>
          {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            React.Children.map<React.ReactElement, any>(children, (element: React.ReactElement) => (
              <Route path={node.getPath(element.type)} render={() => element} />
            ))
          }
        </Switch>
      )}
    </FlowContext.Provider>
  );
};

export default Group;
